var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBgColor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.75H24V23.25H0V18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0175 16.1782L4.5 9.8073L12.1494 2.33003L18.6657 8.69964L11.0175 16.1782ZM6.76642 9.80724L11.0163 13.9615L16.4007 8.69958L12.1495 4.54529L6.76642 9.80724Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0174 14.5159L6.2004 9.80726L6.97551 8.66651H16.5922L11.0174 14.5159Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3005 1.5L12.7167 2.88557L11.5834 3.99329L10.1672 2.60773L11.3005 1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1 8.14627L19.5163 9.53061L18.383 10.6383L16.9668 9.25399L18.1 8.14627Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 14.7375C21 15.9272 19.6476 16.5 19.1969 16.5C18.9214 16.5 17.3938 15.9272 17.3938 14.7375C17.3938 13.5477 18.8625 11.8329 19.1969 11.7999C19.4648 11.7742 21 13.5477 21 14.7375Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBgColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg-color.61b4e17b7597ea986d8a4574916dc914.svg";